import { ENABLE_US_VENDOR_ID, VENDOR_MODE_IS_ENABLED } from '../config/env';
import OrganizationsStore from '../stores/observables/OrganizationsStore';

/**
 * Detect if the app is running in vendor mode (ie. MindTickle)
 * - Can be enabled by setting REACT_APP_VENDOR_MODE_IS_ENABLED=1
 * - Always enabled for all vendors (any value different than ENABLE_US_VENDOR_ID)
 */
export function isVendorMode() {
  // Use env var REACT_APP_VENDOR_MODE_IS_ENABLED=1 to force vendor mode
  if (VENDOR_MODE_IS_ENABLED) {
    return true;
  }

  // Any organization-less context is not in vendor mode (ie. orgs listing)
  const org = OrganizationsStore.getCurrentOrganization();
  if (!org) {
    return false;
  }

  // Get current org vendor id casted to string
  // Fallback to ENABLE_US_VENDOR_ID or unknown (zero)
  const orgVendorId = (org.vendorId || ENABLE_US_VENDOR_ID || 0).toString();
  return orgVendorId !== ENABLE_US_VENDOR_ID;
}

export function getVendorRoomsLabel() {
  return isVendorMode()
    ? 'organization.digital_sales_room_plural'
    : 'organization.rooms';
}
